var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineStore } from "pinia";
import { GalaxyApi } from "@/api";
import {} from "@/api/datasets";
import { useKeyedCache } from "@/composables/keyedCache";
import { rethrowSimple } from "@/utils/simple-error";
export const useDatasetExtraFilesStore = defineStore("datasetExtraFilesStore", () => {
    function fetchDatasetExtraFiles(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data, error } = yield GalaxyApi().GET("/api/datasets/{dataset_id}/extra_files", {
                params: { path: { dataset_id: params.id } },
            });
            if (error) {
                rethrowSimple(error);
            }
            return data;
        });
    }
    const { storedItems, getItemById, isLoadingItem, fetchItemById } = useKeyedCache(fetchDatasetExtraFiles);
    return {
        storedDatasetExtraFiles: storedItems,
        getDatasetExtraFiles: getItemById,
        isLoadingDatasetExtraFiles: isLoadingItem,
        fetchDatasetExtFilesByDatasetId: fetchItemById,
    };
});
